import { continueChat, type ContinueChatResponse } from '@/pages/api/scribeAPIV2';
import { logger } from '@/utils/logger/logger';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_CHATS } from '../query/useQueryChats';
import { GET_SESSION_CHATS } from '../query/useQuerySessionChats';

export function useMutateContinueChat() {
  const queryClient = useQueryClient();

  return useMutation<ContinueChatResponse, Error, string>({
    mutationFn: async (chatId) => {
      const response = await continueChat(chatId);
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [GET_CHATS] }).catch(() => {});

      if (data.session_id) {
        queryClient
          .invalidateQueries({ queryKey: [GET_SESSION_CHATS, data.session_id] })
          .catch(() => {});
      }
    },
    onError: (error) => {
      logger.error('Failed to continue chat', { error });
    },
  });
}
